import moment from 'moment'
import { CHATS_LIST_TYPE } from '@/helpers/chat'

export default {
  // contacts
  // should it be case sensitive?
  filteredContacts: state => search =>
  search
    ? state.contacts.filter(contact => {
      const rexExp = RegExp(search, 'i')

      return rexExp.exec(`${contact.firstName} ${contact.lastName}`)
    })
    : state.contacts,
  selectedContacts: state => state.contacts.filter(contact => contact.isActive), // users will be shown in the same order as in all contact's list. Is this ok?

  // messages
  messagesWithoutDeleted: state => channel => (state.messages[channel] || [])
    .filter(messageWrapper => !messageWrapper.message.deleted),
  currentMessages: state => [...(state.messages[state.currentChannel] || [])],
  currentMessagesLength: (_, getters) => getters.currentMessages.length,
  currentMessageMaxId: (_, getters) => getters.currentMessagesLength === 0
    ? 0
    : getters.currentMessages[getters.currentMessagesLength - 1].message.id,
  unreadedMessages: (state, getters) => state.channels.reduce((acc, channel) => {
    acc[channel.id] = getters.messagesWithoutDeleted(channel.id)
        .filter(msg => !msg.message.is_read && msg.message.user !== state.uuid)
    return acc
  }, {}),
  allUnreadedMessages: (state, getters) => getters.channelsIdsWithoutPersonal.reduce((acc, channelId) => {
    acc += state.unreadMessagesObject[channelId] || 0
    return acc
  }, 0),
  freeChatsUnreadMessages: (state, getters) => getters.channelsIdsFreeChat.reduce((acc, channelId) => {
    acc += state.unreadMessagesObject[channelId] || 0
    return acc
  }, 0),
  normalChatsUnreadMessages: (state, getters) => getters.channelsIdsWithoutPersonalAndFreeChat.reduce((acc, channelId) => {
    acc += state.unreadMessagesObject[channelId] || 0
    return acc
  }, 0),
  lastChatsMessages: (state) => state.channels.reduce((acc, channel) => {
    const name = channel.id
    const messages = (state.messages[name] || [])
    const length = messages.length

    acc[name] = length === 0
      ? {}
      : messages[messages.length - 1].message
    return acc
  }, {}),

  // users
  channelUsers: state => selectedChannel => (state.channels.find(channel => channel.id === selectedChannel) || {}).chatMembers || [],
  directMessageUsers: (state, getters) => getters.channelsWithoutPersonal
    .reduce((acc,channel) => {
      if (!channel.isDirectMessage) {
        return acc
      }
      const uuid = (channel.chatMembers.find(member => member.uuid !== state.uuid) || {}).uuid
      const id = channel.id
      acc.push({ uuid, id })
      return acc
    }, []),

  // channels
  chatSubsribed: state => state.channels.map(channel => channel.id),
  activeWritersNames: (state, getters) => (state.activeWriters[state.currentChannel] || []).map(
      writerUuid => (getters.channelUsers(state.currentChannel).find(user => user.uuid === writerUuid) || {}).fullName
      || writerUuid
  ),
  filteredChannels: (_, getters) => (search, filterChannels = CHATS_LIST_TYPE.ALL) => {
    let channels = [];

    switch (filterChannels) {
      case CHATS_LIST_TYPE.FREE_CHATS:
        channels = getters.channelsFreeChat;
        break;
      case CHATS_LIST_TYPE.NORMAL_CHATS:
        channels = getters.channelsGroupAndDirect;
        break;
      case CHATS_LIST_TYPE.SPRINT_CHATS:
        channels = getters.channelsSprintMessages;
        break;
      default:
        channels = getters.channelsWithoutPersonal;
    }

    return search
      ? channels.filter(channel => {
        const rexExp = RegExp(search, 'i')

        return rexExp.exec(channel.name)
      })
      : channels
  },
  channelPrefix: (state, getters) => getters.personalChannel.id.split(state.uuid)[0],
  personalChannel: state => state.channels.find(channel => channel.id === state.privateChannel) || { id: '' },
  channelsWithoutPersonal: (state, getters) => state.channels.filter(channel => channel.id !== getters.personalChannel.id),
  channelsFreeChat: (state) => state.channels.filter((channel) => !!channel.isFreeUserChat),
  channelsGroupAndDirect: (_, getters) => getters.channelsWithoutPersonal.filter((channel) => !channel.isFreeUserChat && channel.id.indexOf('_sprint_') === -1),
  channelsSprintMessages: (_, getters) => getters.channelsWithoutPersonal.filter((channel) => channel.id.indexOf('_sprint_') >= 0),
  channelsIdsWithoutPersonal: (_, getters) => getters.channelsWithoutPersonal.map(channel => channel.id),
  channelsIdsFreeChat: (_, getters) => getters.channelsFreeChat.map((channel) => channel.id),
  channelsIdsWithoutPersonalAndFreeChat: (_, getters) => getters.channelsGroupAndDirect.map((channel) => channel.id),
  channelsLength: state => state.channels.length,
  sortedChannels: (state, getters) => (search, filterChannels = CHATS_LIST_TYPE.ALL) => getters.filteredChannels(search, filterChannels).sort((a, b) => {
    const messagesA = state.messages[a.id] || [];
    const lastMessageA = messagesA[messagesA.length - 1] || {};
    const dateA = moment(lastMessageA.timetoken ? (Math.floor(lastMessageA.timetoken/Math.pow(10,4))) : a.creationDate).unix();

    const messagesB = state.messages[b.id] || [];
    const lastMessageB = (messagesB)[messagesB.length - 1] || {};
    const dateB = moment(lastMessageB.timetoken ? (Math.floor(lastMessageB.timetoken/Math.pow(10,4))) : b.creationDate).unix();

    const isPinnedA = (a.chatMembers.find(el => el.uuid === state.uuid) || {}).isChatPinned || false;
    const isPinnedB = (b.chatMembers.find(el => el.uuid === state.uuid) || {}).isChatPinned || false;

    return isPinnedB - isPinnedA || dateB - dateA;
  })
}
